<script>
  import Container from "./Container.svelte";
  import Time from "./Time.svelte";
  export let prepare;
</script>

<Container>
  <h4 class="text-base text-center pt-4">prepare</h4>
  <div
    class="flex flex-col justify-center items-center bg-indigo-400 bg-opacity-80 px-1 py-2 rounded-3xl shadow-whitesm"
  >
    <h4 class="mb-2 text-base">time</h4>
    <Time bind:min={prepare.min} bind:sec={prepare.sec} />
  </div>
</Container>
